import './styles.scss';
import ImageMosaic from "../image-mosaic/image-mosaic";
import { useEffect, useState } from 'react';
import SquareImage from '../square-image/square-image';

type Props = {
    title?: string;
    items: Array<{ id: string; name: string; imageUrl: string[] }>;
    onItemClick: (itemId: string) => void;
}


type CloudItemProps = {
    item: { id: string; name: string; imageUrl: string[] };
    onClick: (id: string) => void;
}

const CloudItem = ({ item, onClick }: CloudItemProps) => {
    return (
        <div className="items-cloud__item" onClick={() => onClick(item.id)}>
            <div className="items-cloud__image">
                {item.imageUrl.length === 1 &&
                    <SquareImage fill playlist={{ id: item.id, poster_url: item.imageUrl[0] } as any} alt={item.name} />}
                {item.imageUrl.length > 1 &&
                    <ImageMosaic images={item.imageUrl} />}
            </div>
            <div className="items-cloud__name">{item.name}</div>
        </div>
    )
}

const ItemsCloudView = ({ title, items, onItemClick }: Props) => {
    return (
        <div className="items-cloud">
            {title && <div className="items-cloud__title">Items Cloud</div>}
            <div className="items-cloud__content">
                {items.map(item => (
                    <CloudItem key={item.id} item={item} onClick={onItemClick} />
                ))}
            </div>
        </div>
    );
}

export default ItemsCloudView;
